"use client";

import ForgotPasswordForm from "./auth/ForgotPasswordForm";
import RegisterForm from "./auth/RegisterForm";
import SigninForm from "./auth/SigninForm";
import SigninUnavailable from "./auth/SigninUnavailable";
import Modal from "./Modal";

type Props = {
  /** Whether the DAS platform API is set up; without it the auth modals explain instead of showing their forms. */
  signInAvailable: boolean;
};

/**
 * Every modal the site can open, rendered once by the site frame, in the order
 * footer.php rendered them. Each reads whether it is the active one from the
 * modal context. The forgot-password modal had a modifier of its own in the
 * theme, but its rules were the sign-in ones to the letter, so it is the
 * sign-in variant here.
 *
 * The contact form modal (contact-form-modal.php) is the contact form's own and
 * is not rendered here.
 */
export default function Modals({ signInAvailable }: Props) {
  return (
    <>
      <Modal id="signin-modal" variant="signin" dark>
        {signInAvailable ? <SigninForm /> : <SigninUnavailable />}
      </Modal>

      <Modal id="forgot-password-modal" variant="signin" dark>
        {signInAvailable ? <ForgotPasswordForm /> : <SigninUnavailable />}
      </Modal>

      {/* The theme gave the register modal the sign-in look as well. */}
      <Modal id="register-modal" variant="signin" dark>
        {signInAvailable ? <RegisterForm /> : <SigninUnavailable />}
      </Modal>
    </>
  );
}
